// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'infinity';

export const Component = () => (
  <path d='M12.26 8.023 8.19 4.001 0 12.19l8.19 8.19 4.07-4.023-4.165-4.167 4.166-4.166v-.002Zm12.261 4.167L16.284 4 12.26 8.023l4.119 4.166-4.12 4.166 4.024 4.023 8.237-8.19v.002Z' />
);

export const viewBox = '0 0 25 25';
